import React from "react";
import Slider from "../common/RangeSlider/Slider";
import { cn } from "../../Utils/helper";

const ProgressBar = ({
  currentStep,
  totalSteps,
  className,
  errorSteps = {},
  isReviewed = false,
  hasReceiptIssue = true,
  hasReceiptIssueLocation = true,
  hasReceiptIssueDate = true,
  onStepChange = () => {}, // Callback khi slider thay đổi
  isValidationReceipt = true,
}) => {
  const [value, setValue] = React.useState([currentStep - 1]);

  React.useEffect(() => {
    setValue([currentStep - 1]);
  }, [currentStep]);

  const hasHintError = Boolean(errorSteps?.hint);
  const renderSegments = () => {
    return Array.from({ length: totalSteps }).map((_, index) => {
      const stepNumber = index + 2;
      const isCurrentStep = stepNumber === value[0] + 1;
      const stepWidth = 100 / (totalSteps - 1);
      const isLastStep = index === totalSteps - 1;

      return (
        <div
          className="relative flex items-center"
          key={index}
          style={{ width: `${stepWidth}%` }}
        >
          {isCurrentStep && (
            <span
              className={cn(
                "font-bold absolute",
                hasHintError ? "text-[#EF4056]" : "text-[#253FF6]"
              )}
              style={{
                fontSize: "14px",
                top: "-20px",
                left: isLastStep ? "65%" : "95%",
                transform: "translateX(-50%)",
              }}
            >
              Q{stepNumber - 1}
            </span>
          )}
        </div>
      );
    });
  };

  // const handleValueChange = (newValue) => {
  //   const newStep = Math.ceil(newValue[0]) + 1; // Điều chỉnh để khớp với stepNumber
  //   setValue(newValue);
  //   onStepChange(newStep);
  // };

  return (
    <div className={`w-full ${className} relative `}>
      <Slider
        value={value}
        // onValueChange={handleValueChange}
        max={totalSteps}
        rangeStyle={{
          backgroundColor: hasHintError ? "#EF4056" : "#253FF6",
        }}
        thumbStyle={{
          backgroundColor: hasHintError ? "#EF4056" : "#253FF6",
        }}
        step={1}
        className="w-full px-0"
        style={{
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      />
      <div className="flex w-full h-6 relative pointer-events-none">
        {renderSegments()}
      </div>
    </div>
  );
};

export default ProgressBar;
